import React, { useRef } from "react";
import "../../styles/Hero/Hero.css";
import background1 from "../../assets/videos/afrogotech_web_video.mp4";
import background2 from "../../assets/videos/bg-for-website.mp4";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Typewriter from "typewriter-effect";

export default function Hero() {
  const { t } = useTranslation();

  const videoRef1 = useRef(null);
  const videoRef2 = useRef(null);

  const handleVideo1Ended = () => {
    if (videoRef2.current) {
      videoRef2.current.play();
    }
  };

  return (
    <section className="hero--section">
      <div className="video-background">
        <video
          ref={videoRef1}
          src={background1}
          className="video-background"
          type="video/mp4"
          autoPlay={true}
          muted={true}
          loop={true}
          onEnded={handleVideo1Ended}
        />
        <video
          ref={videoRef2}
          src={background2}
          className="video-background"
          type="video/mp4"
          autoPlay={true}
          muted={true}
          loop={true}
          style={{ display: "none" }}
        />
      </div>
      <div className="hero-content">
        <div className="hero-description">
          <h1>{t("Hero.hero__solutions")}</h1>
          <div className="hero-informations">
            <h1 className="typywriter">
              <Typewriter
                options={{
                  strings: [t('Typewriter.first'),t('Typewriter.second'),t('Typewriter.third')],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 2
                }}
                
              />
            </h1>
          </div>
          <div className="hero-buttons">
            <button className="cssbuttons-io-button">
              {t("Hero.hero__contact")}
              <Link to="/contact-us">
                <div className="icon">
                  <svg
                    height={24}
                    width={24}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </Link>
            </button>

            <button className="cssbuttons-io-button">
              {t("Hero.hero__devis")}
              <Link to="demande-un-devis">
                <div className="icon">
                  <svg
                    height={24}
                    width={24}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </Link>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
